<div class="settings-modal-content">
  <h2 class="mat-h2">Competitors bricks</h2>
  <div class="flex gap-4 items-center">
    <mat-form-field appearance="fill" class="w-1/2">
      <mat-label>Select Region</mat-label>
      <mat-select [(value)]="selectedRegionId" (selectionChange)="onRegionChange()">
        <mat-option *ngFor="let region of regions" [value]="region.id">{{ region.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="text-sm flex items-center gap-4">
      <button type="button" mat-flat-button color="accent" (click)="fileInput1.click()">Import sales</button>
      <input hidden (change)="importCompetitors($event, 'sales')" #fileInput1 type="file" id="file" />
    </div>

    <div class="text-sm flex items-center gap-4">
      <button type="button" mat-flat-button color="accent" (click)="fileInput2.click()">Import patients</button>
      <input hidden (change)="importCompetitors($event, 'patients')" #fileInput2 type="file" id="file" />
    </div>

    <div class="text-sm flex items-center gap-4">
      <button type="button" mat-flat-button color="accent" (click)="fileInput3.click()">Import sales in €</button>
      <input hidden (change)="importCompetitors($event, 'salesInEuro')" #fileInput3 type="file" id="file" />
    </div>
  </div>

  <div *ngIf="selectedRegionId" class="mt-4">

    <!-- Brick List -->
    <div *ngIf="getBricksWithCompetitors(regionBricks).length; else noBricks" class="pb-4">
      <!-- <div *ngFor="let brick of bricks" class="border border-gray-300 rounded-lg p-4 mb-4"> -->
      <div *ngFor="let brick of getBricksWithCompetitors(regionBricks)">

        <div class="brick">
          <h3>Brick: {{ brick.name }} <span>(id: {{ brick.id }})</span></h3>
        </div>

        <div *ngFor="let competitor of brick.salesCompetitors; let i = index" class="competitor">
          <h3>Competitor: {{ competitor.competitorName }} <button mat-icon-button (click)="deleteCompetitor(brick, competitor)" aria-label="Delete" color="error"><mat-icon>delete_forever</mat-icon></button></h3>

          <!-- <div *ngFor="let sale of sortMonths(competitor)" class="sale">
            <p>Month: {{ sale.month }}, Year: {{ sale.year }}</p>
          </div> -->

          <mat-expansion-panel class="mb-2" hideToggle (opened)="panelOpenState[i] = true" (closed)="panelOpenState[i] = false">
            <mat-expansion-panel-header>
              <mat-panel-title class="p-2">{{ panelOpenState[i] ? "hide" : "show" }} competitor sales data<mat-icon *ngIf="!panelOpenState[i]">keyboard_arrow_down</mat-icon> <mat-icon *ngIf="panelOpenState[i]">keyboard_arrow_up</mat-icon></mat-panel-title>
            </mat-expansion-panel-header>
            <div class="px-2">patients momentum (short: {{ getPatientsMomentumShort(competitor).toFixed(2) || 0 }}%, long: {{ getPatientsMomentumLong(competitor).toFixed(2) || 0 }}%)</div>
            <div *ngIf="panelOpenState[i]" class="px-2">
              <h3 class="text-md font-medium mt-2">Add new month</h3>
              <div class="grid grid-cols-2 md:grid-cols-6 gap-4">
                <mat-form-field appearance="fill">
                  <mat-label>Year</mat-label>
                  <input matInput [(ngModel)]="newMonth.year" required />
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>Month</mat-label>
                  <input matInput [(ngModel)]="newMonth.month" required />
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>Packs</mat-label>
                  <input matInput [(ngModel)]="newMonth.sales" required />
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>Patients</mat-label>
                  <input matInput [(ngModel)]="newMonth.patients" required />
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>Sales in €</mat-label>
                  <input matInput [(ngModel)]="newMonth.salesInEuro" required />
                </mat-form-field>
                <button mat-flat-button color="primary" (click)="addMonth(competitor)" [disabled]="!isMonthValid(competitor)"><span>Add month</span></button>
              </div>
              <h4 class="mat-h4">Sales</h4>
              <div *ngFor="let month of sortMonths(competitor)">
                <div class="grid grid-cols-2 md:grid-cols-6 gap-4">
                  <mat-form-field appearance="fill">
                    <mat-label>Year</mat-label>
                    <input matInput [(ngModel)]="month.year" (ngModelChange)="updateMomentum(competitor)" required />
                  </mat-form-field>
                  <mat-form-field appearance="fill">
                    <mat-label>Month</mat-label>
                    <input matInput [(ngModel)]="month.month" (ngModelChange)="updateMomentum(competitor)" required />
                  </mat-form-field>
                  <mat-form-field appearance="fill">
                    <mat-label>Packs</mat-label>
                    <input matInput [(ngModel)]="month.sales" (ngModelChange)="updateMomentum(competitor)" required type="number" />
                  </mat-form-field>
                  <mat-form-field appearance="fill">
                    <mat-label>Patients</mat-label>
                    <input matInput [(ngModel)]="month.patients" (ngModelChange)="updateMomentum(competitor)" required type="number" />
                  </mat-form-field>
                  <mat-form-field appearance="fill">
                    <mat-label>Sales in Euro</mat-label>
                    <input matInput [(ngModel)]="month.salesInEuro" (ngModelChange)="updateMomentum(competitor)" required type="number" />
                  </mat-form-field>

                  <!-- <mat-form-field *ngFor="let competitor of brick.salesCompetitors; let iComp = index" appearance="fill">
                    <mat-label>{{ competitor.competitorName }}</mat-label>
                    <input matInput [(ngModel)]="brick.salesCompetitors[iComp].sales[getCompetitorSaleIndex(sale.month, sale.year, competitor)].sales" required type="number" />
                  </mat-form-field> -->

                  <button mat-icon-button (click)="deleteMonth(competitor, month)" aria-label="Delete" color="error"><mat-icon>delete_forever</mat-icon></button>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </div>

      </div>
    </div>
    <ng-template #noBricks>
      <p>No bricks in this region yet.</p>
    </ng-template>

  </div>
</div>
